var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCardGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 14.1667H29.75M9.91667 21.25H11.3333M17 21.25H18.4167M8.5 26.9167H25.5C27.8472 26.9167 29.75 25.0139 29.75 22.6667V11.3333C29.75 8.98613 27.8472 7.08334 25.5 7.08334H8.5C6.15279 7.08334 4.25 8.98613 4.25 11.3333V22.6667C4.25 25.0139 6.15279 26.9167 8.5 26.9167Z",
    stroke: "#616567",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardGray);
export default __webpack_public_path__ + "static/media/credit-card-gray.492e4eb64fea7de50e4f7a700b1f3f6c.svg";
export { ForwardRef as ReactComponent };